export function assets(asset) {
	return process.env.PUBLIC_URL + asset;
}

export function loader() {
	return <img src={assets('/img/loader.gif')} id="loader" alt="loader" />;
}